// "2025-11-19" -> "19.11.2025."
export const formatDate = (iso) => {
  if (!iso) return '';
  const [y, m, d] = String(iso).split('-');
  if (!y || !m || !d) return String(iso);
  return `${d}.${m}.${y}.`;
};

// today as "2026-09-19"
export const todayIso = () => {
  const n = new Date();
  const p = (v) => String(v).padStart(2, '0');
  return `${n.getFullYear()}-${p(n.getMonth() + 1)}-${p(n.getDate())}`;
};

export const byDateDesc = (a, b) => String(b.date).localeCompare(String(a.date));

export const teamLabel = (team, sep = ' / ') => (Array.isArray(team) ? team.join(sep) : String(team || ''));
